<template>
    <div>
        <label class="block text-sm font-medium text-gray-700">Zonen</label> 
        <select-menu v-model="local" v-show="hasZones"
                    :text="text"
                    :values="values">
            <span v-show="!filter">Zone</span>
        </select-menu>
    </div>
</template>

<script>
import SelectMenu from "./UI/SelectMenu";

export default {
    name: "ZoneSelect",

    components: {SelectMenu},

    props: {
        value: {},
        groups: {},
        filter: {
            default: false,
        },
    },

    computed: {
        text() {
            return ['Alle'].concat(this.groups.map(p => p.name));
        },
        values() {
            return [null].concat(this.groups.map(p => p.id));
        },
        hasZones() {
            return this.groups.length > 0;
        },
        local: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value !== "" ? parseInt(value) : null);
            },
        },
    }
}
</script>

<style scoped>

</style>